import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UpdateActiveStatusRequest } from 'src/app/shared/models/azure-namespaces.model';
import { BACKBONE_URL, PAGE_RESULT_SIZE } from '../../shared/constants';
import { AzureAccount } from '../../shared/models/azure-accounts.model';

@Injectable({
  providedIn: 'root'
})
export class AzureAccountsService {

  constructor(private httpClient: HttpClient) { }

  public getRecordCounts(filter: string = null) {
    let address = BACKBONE_URL + `AzureAccounts/count`;

    if (filter)
      address = `${address}?filter=${filter}`;

    return this.httpClient.get(address);
  }

  public getAccounts(pageNo: number, pageSize: number = PAGE_RESULT_SIZE, filter: string = null) {
    let address = BACKBONE_URL + `AzureAccounts?page=${pageNo}&result=${pageSize}`;



    if (filter)
      address = `${address}&filter=${filter}`;

    return this.httpClient.get(address);
  }

  public getAccountById(id: number) {
    let address = BACKBONE_URL + `AzureAccounts/${id}`;
    return this.httpClient.get(address);
  }

  public createAccount(model: AzureAccount) {
    let address = `${BACKBONE_URL}AzureAccounts`;
    return this.httpClient.post(address, model);
  }

  public updateAccount(model: AzureAccount) {
    let address = `${BACKBONE_URL}AzureAccounts/${model.Id}`;
    return this.httpClient.put(address, model);
  }

  public deleteAccount(id: number) {
    let address = `${BACKBONE_URL}AzureAccounts/${id}`;
    return this.httpClient.delete(address);
  }

  public updateActiveStatus(model: UpdateActiveStatusRequest) {
    const address = `${BACKBONE_URL}AzureAccounts/update-active-status/${model.id}`;
    return this.httpClient.put(address, model);
  }

}
